import { Box, Switch, Typography } from "@material-ui/core";
import React from "react";

export const NotificationItem = ({
  text,
  inset,
  checked,
  onToggle,
}: {
  text: string;
  inset?: boolean;
  checked: boolean;
  onToggle: (checked: boolean) => void;
}) => (
  <Box
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    pl={inset ? "30px" : 0}
  >
    <Typography variant="h4">{text}</Typography>
    <Switch
      size="small"
      checked={checked}
      color="secondary"
      onChange={(e) => onToggle(e.target.checked)}
    />
  </Box>
);
